// Components==============
import React, { useContext } from 'react';
import { GlobalContext } from 'utilities/GlobalContextWrapper';
import './index.module.scss';
// =========================

export default function Background({ children }) {
    const { isDashboard } = useContext(GlobalContext);

    return (
        <div
            styleName="wrapper"
            style={{ backgroundColor: isDashboard ? '#1e265c' : '#f1f0ea' }}
        >
            {children}
        </div>
    );
}
